module.exports = __webpack_public_path__ + "img/emptyprivilageBig.354fe457.svg";